import React from 'react';
import { useMediaQuery, useTheme, makeStyles } from '@material-ui/core';

import DateRangePicker from '../DateRangePicker';

import StatusFilter from './StatusFilter';
import ClearFiltersButton from './ClearFiltersButton';
import CategoryFilter from './CategoryFilter';
import { useFilterContext } from './FilterProvider';
import { STATUS, DEVELOPMENT_STATUS, STATUS_TYPES } from '../../utils/const';

const useStyles = makeStyles({
  row: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    gridGap: 8,
    alignItems: 'center',
    '&:not(:last-child)': {
      marginBottom: 8
    }
  },
  filterGroup: {
    display: 'flex',
    gridGap: 8
  }
}, { name: 'Filters' });

const Filters = () => {
  const classes = useStyles();
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.up('sm'));

  const {
    statusFilters,
    handleStatusFiltersChange,
    developmentStatusFilters,
    handleDevelopmentStatusFiltersChange,
    categoryFilters,
    handleCategoryFiltersChange,
    dateRange,
    setDateRange
  } = useFilterContext();

  return (
    <>
      {sm ?
        <div className={ classes.row }>
          <div className={ classes.filterGroup }>
            <StatusFilter
              type={ STATUS_TYPES.STATUS }
              statuses={ Object.values(STATUS) }
              handleStatusFilter={ handleStatusFiltersChange }
              statusFilters={ statusFilters }
            />
            <StatusFilter
              type={ STATUS_TYPES.DEVELOPMENT_STATUS }
              statuses={ Object.values(DEVELOPMENT_STATUS) }
              handleStatusFilter={ handleDevelopmentStatusFiltersChange }
              statusFilters={ developmentStatusFilters }
              disabled={ !statusFilters.includes(STATUS.ACTIVE) ||
                (statusFilters.length > 1 && statusFilters.includes(STATUS.ACTIVE)) }
            />
            <CategoryFilter
              handleCategoryFilter={ handleCategoryFiltersChange }
              categoryFilters={ categoryFilters }
            />
          </div>
          <div className={ classes.filterGroup }>
            <DateRangePicker
              selectedDateRange={ dateRange }
              setSelectedDateRange={ setDateRange }
            />
          </div>
          <ClearFiltersButton />
        </div> :
        <ClearFiltersButton />
      }
    </>
  );
};

export default Filters;
